export const ERROR_PAGE_ROUTE = '/error';
export const PURCHASE_AGREEMENT_PAGE_ROUTE = (referralUUID: string) =>
  `/purchase-agreement/${referralUUID}`;
export const REFERRAL_DASHBOARD_ROUTE = '/referral-dashboard';
export const REPORTING_DASHBOARD_ROUTE = '/reports';
export const SINGLE_REPORT_PAGE_ROUTE = '/reports/:reportId';
export const DEVELOPER_DASHBOARD_ROUTE = '/developer';
export const LIST_WITH_CERTAINTY_DASHBOARD_ROUTE = '/lwc-dashboard';
export const LIST_WITH_CERTAINTY_BROKERAGE_DASHBOARD_ROUTE = '/lwc-dashboard/brokerage';
export const PARTNER_AGENT_REFERRAL_NETWORK_DASHBOARD_ROUTE = '/parn-dashboard';
export const SIGN_UP_ROUTE = '/sign-up';
export const SUBSCRIPTION_PREFERENCES_ROUTE = '/subscription-preferences';
export const WELCOME_LEAD_ROUTE = '/welcome';
export const WELCOME_REDIRECT_ROUTE = '/welcome-redirect';
